module.exports = __webpack_public_path__ + "media/images/advisor/img_4_1-520328032fee54235dbc01cac77db6eb.png";